module.exports = " <div class=row> <div class=col-md-12> <div ng-include=\"'extension-header-projects'\"></div> </div> <div class=\"col-md-12 blanco\"> <div ng-include=\"'extension-projects-list'\"></div> <div ng-include=\"'extension-projects-details'\"></div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/workplan/extensionVisibility/extensionProjects/list/extensionProjectsList.html
// module id = 630
// module chunks = 0